import { Message, Spinner } from 'Components/Core';
import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { GaugeStandardisationSingular } from 'Components/Equipment/NuclearDensityGaugeStandardisation';
import { StandardisationInjectedPropsProvider } from 'Components/Equipment/NuclearDensityGaugeStandardisation/Core/ProviderProps';
import GaugeStandardisationBulkEntry from 'Components/Equipment/NuclearDensityGaugeStandardisation/GaugeStandardisationBulkEntry';
import FixedStandardisationHeader from 'Components/Equipment/NuclearDensityGaugeStandardisation/Header/FixedStandardisationHeader';
import { PageSection } from 'Components/Layout';
import Page from 'Components/Pages/Core/Page';
import { actions as appActions } from 'Data/ReduxViewModels/App';
import { TitleSource } from 'Data/ReduxViewModels/App/types';
import { actions } from 'Data/ReduxViewModels/NuclearGaugeStandardisation';
import { hasValue } from 'Lib/Any';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

let NuclearGaugeStandardisationPage: React.FC = () => {
  const params = useParams();
  const equipmentId = params.equipmentId?.toLowerCase();
  const bulkEntry = !hasValue(equipmentId);
  const ready = useSelector((s) => s.gaugeStandardisation.status.ready);
  const selectedEquipment = useSelector((s) => s.gaugeStandardisation.query?.SelectedGauge);
  const dispatch = useDispatch();

  const standardisationLoaded = useSelector((s) => !!s.gaugeStandardisation.syncModel);

  const InjectedPropsProvider = StandardisationInjectedPropsProvider;

  useEffect(() => {
    if (hasValue(equipmentId) || hasValue(selectedEquipment))
      dispatch(actions.init({ equipmentId: equipmentId ?? selectedEquipment?.Id }));
  }, [dispatch, equipmentId, selectedEquipment]);

  useEffect(() => {
    dispatch(appActions.setPageTitle({ pageTitle: 'Nuclear Gauge Standardization', source: TitleSource.Specific }));
    return () => {
      dispatch(appActions.setPageTitle({ pageTitle: undefined, source: TitleSource.Specific }));
    };
  }, [dispatch]);

  if (!bulkEntry && !ready) {
    return (
      <Page>
        <Spinner large />
      </Page>
    );
  } else if (!bulkEntry && !standardisationLoaded) {
    return (
      <Page>
        <PageSection>
          <Message warning>No Standardisation loaded.</Message>
        </PageSection>
      </Page>
    );
  } else {
    return (
      <Page>
        <div className="StandardisationPage">
          <InjectedPropsProvider>
            <NamePrefixModifier namePrefix="data">
              <FixedStandardisationHeader />
              <div className="StandardisationPage-Content">
                {bulkEntry ? <GaugeStandardisationBulkEntry /> : <GaugeStandardisationSingular />}
              </div>
            </NamePrefixModifier>
          </InjectedPropsProvider>
        </div>
      </Page>
    );
  }
};

export default NuclearGaugeStandardisationPage;
